module.exports = __webpack_public_path__ + "img/cetus.2211b02c.png";